export default "__VITE_ASSET__CzEkJaCV__"